module.exports = __webpack_public_path__ + "img/premio6.78634027.jpeg";